import React from 'react';
import { Icon } from 'semantic-ui-react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import BlockLabel from './block-label';

const tabulateDemographics = demographics => {
  const demographicsTable = {};
  const AGE_BUCKET_REGEX = /([a-zA-Z])+/gi;
  const total = {
    M: 0,
    F: 0,
  };
  _.map(demographics, (value, key) => {
    const [gender, ageGroup] = _.tail(_.split(key, AGE_BUCKET_REGEX));
    total[gender] += value.percentage;
    if (!demographicsTable[ageGroup]) {
      demographicsTable[ageGroup] = {};
    }
    demographicsTable[ageGroup][gender] = value;
  });
  const demographicsArray = Object.entries(demographicsTable);
  console.log(demographicsArray);
  demographicsArray.sort((a, b) => {
    const [aValue] = _.tail(a);
    const [bValue] = _.tail(b);
    return (bValue.M.percentage + bValue.F.percentage) -
    (aValue.M.percentage + aValue.F.percentage);
  });
  console.log(total);
  return {
    demographicsTable: demographicsArray,
    total,
  };
};

const leftAlign = {
  textAlign: 'left',
};

const padding20 = {
  padding: 20,
  height: 150,
};

const Audience = props => {
  const { profile } = props;

  if (!_.has(profile, 'demographics.dyzioDemographics')) {
    return (
      <div style={padding20}>
        <div>
          <h4 style={leftAlign}>
            <span>Audience Data no available</span>
          </h4>
        </div>
        <BlockLabel label="Top Audience" />
      </div>
    );
  }

  const audienceDemographics = { data: _.get(profile, 'demographics.dyzioDemographics') };
  const { demographicsTable } = tabulateDemographics(audienceDemographics.data);

  console.log('demographicsTable', demographicsTable);

  const AgeGroups = [];
  _.forEach(demographicsTable, group => {
    AgeGroups.push({
      label: `Female ${_.head(group)}`,
      percentage: _.last(group).F.percentage,
    });

    AgeGroups.push({
      label: `Male ${_.head(group)}`,
      percentage: _.last(group).M.percentage,
    });
  });

  const sortedAgeGroups = _.reverse(_.sortBy(AgeGroups, 'percentage'));
  const topAgeGroups = _.take(sortedAgeGroups, 3);

  return (
    <div style={padding20}>
      {_.map(topAgeGroups, group => (
        <div>
          <h4 style={leftAlign}>
            <div style={{ float: 'right' }}>{group.percentage}%</div>
            <Icon 
              name={_.includes(group.label, 'Female') ? 'female' : 'male'} 
              color={_.includes(group.label, 'Female') ? 'pink' : 'blue'}  
            /> {group.label}
          </h4>
        </div>
      ))}
      <BlockLabel label="Top Audience" />
    </div>
  );
};

Audience.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default Audience;



// WEBPACK FOOTER //
// ./src/containers/summary/components/audience.js